import { unreachable } from './unreachable';

type Empty = ['empty'];
type Loading<T> = ['loading', Promise<T>];
type Loaded<T> = ['loaded', T];
type Cache<T> = Empty | Loading<T> | Loaded<T>;

type ArgumentTypes<F> = F extends (...args: infer A) => any ? A : never;
type PromiseSupplier<T> = (...args: any[]) => Promise<T>;

export const cache = <T, F extends PromiseSupplier<T>>(
  supplier: F,
  timeout: number,
): F => {
  let cache_object: Cache<T> = ['empty'];

  return ((...args: ArgumentTypes<F>): Promise<T> => {
    switch (cache_object[0]) {
      case 'empty': {
        const promise = supplier(...args).then((value) => {
          cache_object = ['loaded', value];
          window.setTimeout(() => {
            cache_object = ['empty'];
          }, timeout);

          return value;
        });

        cache_object = ['loading', promise];

        return promise;
      }
      case 'loading':
        return cache_object[1];
      case 'loaded':
        return Promise.resolve(cache_object[1]);
      default:
        return unreachable(cache_object);
    }
  }) as any;
};
